import { updateT11nTranscriptCache } from '@/hooks/query/useQueryT11nTranscriptBySessionId';
import { updateSessionById } from '@/pages/api/scribeAPI';
import { reactQueryClient } from '@/utils/reactQueryClient';
import { scribeHttpV2 } from '@/utils/scribeHTTP';
import { GET_SESSION_BY_ID, type QuerySessionResponse } from '@heidi/session/contracts';
import { produce } from 'immer';

const seedRecordingInT11nCache = (sessionId: string, recordingId: string) => {
  updateT11nTranscriptCache(sessionId, (state) => ({
    ...state,
    recordings: [
      ...state.recordings,
      {
        recording_id: recordingId,
        start_date: new Date().toISOString(),
        chunks: [],
        issues: [],
      },
    ],
  }));
};

export const getRecordingId = async (
  sessionId: string,
  useTranscriptionServiceV2: boolean
) => {
  let recordingId;

  if (useTranscriptionServiceV2) {
    recordingId = crypto.randomUUID();
    seedRecordingInT11nCache(sessionId, recordingId);
  } else {
    const response = await scribeHttpV2.post<{ recording_id: string }>(
      `/sessions/${sessionId}/restful-segment-transcription`
    );
    recordingId = response.data.recording_id;
  }

  if (useTranscriptionServiceV2) {
    await updateSessionById(sessionId, {
      generate_output_without_recording: false,
    });
  }
  reactQueryClient.setQueryData<QuerySessionResponse>(
    [GET_SESSION_BY_ID, { sessionId }],
    (old) => {
      if (!old) {
        return old;
      }
      return produce(old, (draft) => {
        draft.generate_output_without_recording = false;
      });
    }
  );

  return recordingId;
};
